<template>
  <b-modal
    v-model="shown"
    size="md"
    centered
    title="External Analytics API"
    no-close-on-esc
    no-close-on-backdrop>

    <b-form-group label="API Endpoint URL">
      <b-form-input
        size="lg"
        v-model="url"
        type="text"
        placeholder="API Endpoint"
        :state="showErrors && !url ? false : null"
        required/>
    </b-form-group>

    <b-form-group label="API KEY">
      <b-form-input
        size="lg"
        v-model="key"
        type="text"
        placeholder="API KEY"
        :state="showErrors && !key ? false : null"
        required/>
    </b-form-group>

    <div slot="modal-footer" style="width: 100%">
      <div class="text-right">
        <b-button
          @click="onClose"
          :disabled="isSaving"
          variant="outline"
          class="px-3"
          size="md">
          Cancel
        </b-button>
        <b-button
          @click="onSave"
          :disabled="isSaving"
          variant="success"
          class="px-3"
          size="md">
          <i class="fa fa-spinner fa-spin mr-2" v-if="isSaving"/>
          Save
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import axios from 'axios';
  import {fullURL} from '../../utils';

  export default {
    name: 'ExternalAnalyticsEditor',

    data() {
      return {
        shown: true,
        isSaving: false,
        showErrors: false,
        url: '',
        key: '',
      };
    },

    methods: {
      onClose() {
        this.shown = false;
        this.$emit('close');
      },

      onSave() {
        const {url, key} = this;

        if (!key || !url) {
          this.showErrors = true;
          return;
        }

        this.isSaving = true;
        axios.post(fullURL(`/external-analytics`), {url, key})
          .then(({data}) => {
            this.isSaving = false;
            this.shown = false;
            this.$emit('close', data);
          })
          .catch(e => {
            this.isSaving = false;
            console.log(e);
          });
      }
    },
  };
</script>

<style>

</style>
